import { BalanceType, WalletType } from 'config/types/Wallet'
import { useSelector } from 'react-redux'
import { AppState } from 'state'

export const useGetOpvWallet = (): WalletType => {
  return useSelector<AppState, AppState['wallet']['opvWallet']>((state) => state.wallet.opvWallet)
}

export const useGetUsdtWallet = (): WalletType => {
  return useSelector<AppState, AppState['wallet']['usdtWallet']>((state) => state.wallet.usdtWallet)
}

export const useGetWalletBalance = (): BalanceType[] => {
  return useSelector<AppState, AppState['wallet']['balances']>((state) => state.wallet.balances)
}
